import { isDesktopView } from './detect'
import { hasAllValuesAtPaths } from './test-object-condition'
import { sendRequest } from '../modules/lib-alme-request/src/lib-alme-request';

export const allowNav = (currentWin, settings) => {
    let shouldAutoNav = shouldNav(currentWin, settings);       
    if(!shouldAutoNav){
        const userNavs = window.confirm(settings.textConstants.confirmText);
        const reportingInput = {
            eventName: 'DNNWarningAccepted',
            eventVale: userNavs,
        };
        sendRequest(reportingInput);
        
        const input= {
            messageType: settings.messageConstants.appeventRequest,
            eventName: settings.appeventConstants.dnnPromptEventName,
            origin: settings.originConstants.internal,
            parameters: { UserAcceptsPrompt: userNavs },
        };
        sendRequest(input);

        return userNavs;
    }

    return true;

}

export const isDNNLocation = (currentWin, settings) => {
    return settings.DNN.urls.reduce((result, condition) => {
        const currentResult = hasAllValuesAtPaths(condition, currentWin);
        return result || currentResult; 
    }, false);
}

export const deviceAllowsAutoNav = (settings, store) => {
    if(isDesktopView(settings)){
        return true
    }

    let deviceStateLocation = `${settings.stateLocations.DeviceType}`;

    let device = store.getState()[deviceStateLocation];

    return device === settings.mobileConstants.deviceTypes.tablet;
}

export const shouldNav = (winLocation, settings) => {
    //navigate if the setting is not there
    if(!settings.DNN || !settings.DNN.urls || !Array.isArray(settings.DNN.urls)){
        return true;
    }

    return !isDNNLocation(winLocation, settings);
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/util/dnn.js